import { render, staticRenderFns } from "./KnEmployeeTypes.vue?vue&type=template&id=1212cf5c&"
import script from "./KnEmployeeTypes.vue?vue&type=script&lang=js&"
export * from "./KnEmployeeTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports